<template>
  <div v-if="$store.getters['user/user'].lists.carMakes.length > 0">
    <p v-if="$store.getters['user/user'].registrationplateerrormessagekey === 'mmvIdentification'">{{ mmvIdentificationErrorMessage }}</p>
    <p v-if="$store.getters['user/user'].registrationplateerrormessagekey === 'cdkMmvIdentification'">{{ cdkMmvIdentificationErrorMessage }}</p>
    <p v-if="$store.getters['user/user'].registrationplateerrormessagekey === 'datamannMmvIdentification'">{{ datamannMmvIdentificationErrorMessage }}</p>
    

    <v-row align="center">
      <MMVSelect
        v-on:childToParent="makeChanged"
        :items="$store.getters['user/user'].lists.carMakes"
        :defaultItemText="this.text.selectMake"
        :type="'Make'"
      />

      <MMVSelect
        v-on:childToParent="modelChanged"
        :items="$store.getters['user/user'].lists.carModels"
        :defaultItemText="this.text.selectModel"
        :type="'Model'"
      />

      <MMVSelect
        v-on:childToParent="variantChanged"
        :items="$store.getters['user/user'].lists.carVariants"
        :defaultItemText="this.text.selectVariant"
        :type="'Variant'"
      />
      <v-col cols="12" class="mb-3 red--text" style="margin-top: -24px" v-if="showErrorOnNoVariant">
        <span>{{ text.showErrorOnNoVariant }}</span>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import Vue from 'vue';
import localizationTexts from '@/localization/texts.json';
import { createNamespacedHelpers } from 'vuex';
import MMVSelect from '@/components/fragments/MMVSelect.vue';
const { mapGetters } = createNamespacedHelpers('user');

export default Vue.extend({
  name: 'CustomVehicleSelectors',
  data() {
    return {
      showErrorOnNoVariant: false,
      value: {
        make: { code: '', name: '' },
        model: { code: '', name: '' },
        variant: { code: '', name: '' }
      },
      text: {
        selectMake: '',
        selectModel: '',
        selectVariant: '',
        showErrorOnNoVariant: ''
      },
      mmvIdentificationErrorMessage: '',
      cdkMmvIdentificationErrorMessage: '',
      datamannMmvIdentificationErrorMessage: ''
    };
  },
  components: {
    MMVSelect
  },
  mounted() {
    this.text.selectMake = localizationTexts[this.user.config.language].pageIntro.selectMake;
    this.text.selectModel = localizationTexts[this.user.config.language].pageIntro.selectModel;
    this.text.selectVariant = localizationTexts[this.user.config.language].pageIntro.selectVariant;
    this.text.showErrorOnNoVariant = localizationTexts[this.user.config.language].validation.events.showErrorOnNoVariantEvent;
    this.mmvIdentificationErrorMessage = localizationTexts[this.user.config.language].pageIntro.mmvIdentification;
    this.cdkMmvIdentificationErrorMessage = localizationTexts[this.user.config.language].pageIntro.cdkMmvIdentification;
    this.datamannMmvIdentificationErrorMessage = localizationTexts[this.user.config.language].pageIntro.datamannMmvIdentification;
  },
  methods: {
    makeChanged(data) {
      this.$store.dispatch('user/initLoading', true);
      this.$store.dispatch('user/initListCarModelsManualReset');
      this.$store.dispatch('user/initListCarVariantsManualReset');
      this.$store.dispatch('user/initListSelectedIndexModel', 0);
      this.$store.dispatch('user/initListSelectedIndexVariant', 0);
      this.user.car.modelcode = '';
      this.user.car.modeltext = '';
      this.user.car.variantcode = '';
      this.user.car.varianttext = '';

      this.value.make.code = data.item.value;
      this.$store.dispatch('user/initCarDetailMakeManual', data.item.text);
      this.$store.dispatch('user/initListSelectedIndexMake', data.selectedIndex);
      // get models
      const payloadModels = {
        endpoint: this.user.config.parameters.api + '/maintenance/GetModelsData',
        params: {
          token: this.user.token,
          traceid: this.user.guid,
          culture: this.user.config.parameters.parameters.culture,
          makecode: this.value.make.code,
          rooftopids: this.user.rooftopids,
          test: this.user.config.parameters.parameters.test
        }
      };

      this.$store.dispatch('user/initListCarModelsManual', payloadModels).then(() => {
        //if no data blagh
        this.$store.dispatch('user/initLoading', false);
        this.showErrorOnNoVariant = this.$store.getters['user/user'].lists.carModels.length == 0;
      });
    },
    modelChanged(data) {
      this.showErrorOnNoVariant = false;
      this.user.car.variantcode = '';
      this.user.car.varianttext = '';
      if (data && data.selectedIndex != -1) {
        this.$store.dispatch('user/initLoading', true);
        this.$store.dispatch('user/initListCarVariantsManualReset');
        this.$store.dispatch('user/initListSelectedIndexVariant', 0);
        this.value.model.code = data.item.value;
        this.$store.dispatch('user/initCarDetailModelManual', data.item.text);
        this.$store.dispatch('user/initListSelectedIndexModel', data.selectedIndex);

        // get variants
        const payloadVariants = {
          endpoint: this.user.config.parameters.api + '/maintenance/GetVariantsData',
          params: {
            token: this.user.token,
            traceid: this.user.guid,
            culture: this.user.config.parameters.parameters.culture,
            modelcode: this.value.model.code,
            makecode: this.value.make.code,
            rooftopids: this.user.rooftopids,
            test: this.user.config.parameters.parameters.test
          }
        };
        this.$store.dispatch('user/initListCarVariantsManual', payloadVariants).then(() => {
          this.$store.dispatch('user/initLoading', false);
          this.showErrorOnNoVariant = this.$store.getters['user/user'].lists.carVariants.length == 0;
        });
      }
    },
    variantChanged(data) {
      this.value.variant.code = '';
      this.showErrorOnNoVariant = false;
      if (data && data.selectedIndex != -1) {
        this.value.variant.code = data.item.value;
        this.$store.dispatch('user/initCarDetailVariantManual', data.item.text);
        this.$store.dispatch('user/initListSelectedIndexVariant', data.selectedIndex);
        this.setEligableDepartments(this);
      }
    },
    setEligableDepartments: (that) => {
      that.$store.dispatch('errors/resetErrors', 'departments');

      if (that.registrationplate !== '') {
        that.$store.dispatch('user/initLoading', true);
        const payload = {
          endpoint: that.user.config.parameters.api + '/department/eligable',
          params: {
            rooftopids: that.user.rooftopids,
            traceid: that.user.guid,
            makename: that.user.car.maketext,
            test: that.user.config.parameters.parameters.test
          }
        };
        that.$store.dispatch('user/initListEligableDepartments', payload).then(() => {
          that.$store.dispatch('user/initLoading', false);
          that.setDepartments(that);
        });
      }
    },
    setDepartments: (that) => {
      if (that.user.lists.departments.eligable.length > 0) {
        that.$store.dispatch('user/initListDepartments').then(() => {
          if (that.user.lists.departments.output.length > 0 && that.registrationplate !== '') {
            that.user.lists.departments.output.forEach((item) => {
              that.setCarMake(that, item);
            });
          }
        });
      }
    },
    setCarMake: (that, item) => {
      const payloadMake = {
        endpoint: that.user.config.parameters.api + '/maintenance/GetMakeData',
        params: {
          token: that.user.token,
          traceid: that.user.guid,
          makename: that.user.car.maketext,
          culture: that.user.config.parameters.parameters.culture,
          rooftopid: item.rooftopid,
          test: that.user.config.parameters.parameters.test
        }
      };
      if (that.registrationplate !== '') {
        that.$store.dispatch('user/initCarDetailMake', payloadMake).then(() => {
          that.setServicesList(that, item);
          that.setCarModel(that, item);
        });
      }
    },
    setCarModel: (that, item) => {
      const payloadModel = {
        endpoint: that.user.config.parameters.api + '/maintenance/GetModelData',
        params: {
          token: that.user.token,
          traceid: that.user.guid,
          makecode: that.user.car.makecode,
          modelName: that.user.car.modeltext,
          culture: that.user.config.parameters.parameters.culture,
          rooftopid: item.rooftopid,
          test: that.user.config.parameters.parameters.test
        }
      };
      if (that.registrationplate !== '') {
        that.$store.dispatch('user/initCarDetailModel', payloadModel).then(() => {
          that.setCarVariant(that, item);
        });
      }
    },
    setCarVariant: (that, item) => {
      const payloadVariant = {
        endpoint: that.user.config.parameters.api + '/maintenance/GetVariantData',
        params: {
          token: that.user.token,
          traceid: that.user.guid,
          makecode: that.user.car.makecode,
          modelcode: that.user.car.modelcode,
          culture: that.user.config.parameters.parameters.culture,
          rooftopid: item.rooftopid,
          test: that.user.config.parameters.parameters.test
        }
      };
      if (that.registrationplate !== '') {
        that.$store.dispatch('user/initCarDetailVariant', payloadVariant);
      }
    },
    setServicesList: (that, item) => {
      const payload = {
        endpoint: that.user.config.parameters.api + '/maintenance/services',
        params: {
          token: that.user.token,
          traceid: that.user.guid,
          rooftopid: item.rooftopid,
          cultureName: that.user.config.parameters.parameters.culture,
          makecode: item.car.makecode,
          estodometer: that.user.car.estodometer,
          disableservicecomments: that.user.config.parameters.parameters.disableservicecomments
        }
      };
      that.$store.dispatch('user/initListServices', payload).then(() => {
        if (that.user.lists.departments.output.length === 1) {
          const data = {
            change: true,
            response: that.user.lists.departments.output[0]
          };
          that.$store.dispatch('user/initDepartment', data);
        } else if (that.user.selectedRooftopid !== undefined && that.user.selectedRooftopid !== '') {
          let filtered = that.user.lists.departments.output.filter(function (item) {
            return item.rooftopid === that.user.selectedRooftopid;
          });
          if (filtered.length === 1) {
            const data = {
              change: true,
              response: filtered[0]
            };
            that.$store.dispatch('user/initDepartment', data);
          }
        }
      });
    }
  },
  computed: mapGetters(['user'])
});
</script>

<style scoped lang="scss">
@import './src/assets/scss/_variables.scss';
</style>

<i18n src="../localization/texts.json"></i18n>
